import type { VehicleInfoSuggestion, VehicleSuggestionAPI } from './Types';

export const VehicleSuggestionAPIToVehicleSuggestion = (suggestionAPI: VehicleSuggestionAPI): VehicleInfoSuggestion => ({
  plate: suggestionAPI.plate,
  brand: suggestionAPI.make,
  model: suggestionAPI.model,
  year: suggestionAPI.year,
  grossVehicleWeight: suggestionAPI.grossVehicleWeight ?? null,
  subsegment: suggestionAPI.subsegment ?? null,
});

export default VehicleSuggestionAPIToVehicleSuggestion;
